import styled from '@emotion/styled'
import { Flex } from '../atoms/Basics'
import { MediaQueries as Mq } from '../../styles/settings/theme'

const LegendColor = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  background-color: ${(props) => props.color};
  ${Mq.sm} {
    width: 1rem;
    height: 1rem;
  }
  ${Mq.xs} {
    width: 0.5rem;
    height: 0.5rem;
  }
`
const LegendLabel = styled.p`
  font-size: ${(props) => props.theme.fontSizes[0]};
  margin: 0 0.5rem;
  ${Mq.sm} {
    font-size: 11px;
    margin: 0 0.25rem;
  }
  ${Mq.xs} {
    font-size: 9px;
    margin: 0 0.25rem;
  }
`

const LegendColors = ({ colors, columns }) => {
  return (
    <>
      {colors.map((color, i) => (
        <Flex key={color} alignItems="center">
          <LegendColor color={color} />
          <LegendLabel>{columns ? columns[i] : null}</LegendLabel>
        </Flex>
      ))}
    </>
  )
}

export default LegendColors
